module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/Sports/color/old_basketball-f3a2aaddc6812fd13e7b321a5f0b4878.svg";